/* tslint:disable */
/* eslint-disable */
/**
 * Unified API STS Service Public
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { TokenResponse } from '../models';
/**
 * SecureTokenServiceApi - axios parameter creator
 */
export const SecureTokenServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate to Unified API
         * @param {object} body 
         * @param {string} [disableCache] If set to value \&#39;true\&#39; or \&#39;True\&#39; or \&#39;1\&#39;, a new token will be generated on every request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        token: async (body: object, disableCache?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('token', 'body', body)
            const localVarPath = `/sts/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disableCache !== undefined) {
                localVarQueryParameter['disableCache'] = disableCache;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecureTokenServiceApi - functional programming interface
 */
export const SecureTokenServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecureTokenServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate to Unified API
         * @param {object} body 
         * @param {string} [disableCache] If set to value \&#39;true\&#39; or \&#39;True\&#39; or \&#39;1\&#39;, a new token will be generated on every request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async token(body: object, disableCache?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.token(body, disableCache, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecureTokenServiceApi.token']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SecureTokenServiceApi - factory interface
 */
export const SecureTokenServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecureTokenServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate to Unified API
         * @param {SecureTokenServiceApiTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        token(requestParameters: SecureTokenServiceApiTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.token(requestParameters.body, requestParameters.disableCache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for token operation in SecureTokenServiceApi.
 */
export interface SecureTokenServiceApiTokenRequest {
    readonly body: object

    /**
     * If set to value \&#39;true\&#39; or \&#39;True\&#39; or \&#39;1\&#39;, a new token will be generated on every request
     */
    readonly disableCache?: string
}

/**
 * SecureTokenServiceApi - object-oriented interface
 */
export class SecureTokenServiceApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate to Unified API
     * @param {SecureTokenServiceApiTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public token(requestParameters: SecureTokenServiceApiTokenRequest, options?: RawAxiosRequestConfig) {
        return SecureTokenServiceApiFp(this.configuration).token(requestParameters.body, requestParameters.disableCache, options).then((request) => request(this.axios, this.basePath));
    }
}

